<template lang="html">

  <section class="video-visualizer" :show="show ? 'true' : 'false'">
    <div class="contenedor-video">
      <button @click="closeVideo" class="cerrar">✕</button>
      <iframe   allowscriptaccess="always" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen :src="'https://www.youtube.com/embed/'+[id]+'?enablejsapi=1&version=3&playerapiid=ytplayer'"></iframe> 
    </div>
  </section>

</template>

<script lang="js">

  export default  {
    name: 'video-visualizer',
    props: ['id','show'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      closeVideo : function(){
        this.$emit('closeVideo');
      }
    }

}
</script>

<style scoped>

.video-visualizer{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 20;
  transform: translateY(110vh);
  opacity: 0;
  transition: opacity .2s 0s, transform .2s .25s; 
}

.video-visualizer[show="true"]{
  opacity: 1;
  transform: translateY(0);
  transition: opacity .2s .25s, transform .2s 0s;
}


.contenedor-video{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-align-items: center;
}

iframe{
  width: 100vw;
  height: 100vh;
  border: none;
  transition: transform .8s .5s, box-shadow .4s 1.4s;
  transform: translateY(150vh);
}

[show="true"] iframe{
  transform: translateY(0);
  box-shadow: 1px 1px 50px 2px rgba(0, 0, 0, 0.76);
}

.cerrar{
  position: absolute;
  right: 40px;
  top:100px;
  background: none;
  border: none;
  font-size: 30px;
  color: white;
  cursor:pointer;
  transition: .3s;
  outline: none;
  z-index: 4;
}



@media screen and (max-width: 1300px){

  iframe{
    height: 42.18vw;
  }

}



</style>



// WEBPACK FOOTER //
// src/components/parts/video-visualizer.vue